import type { NpcHullTier, PlayerShip } from "../types";

// Ship silhouette icons (design doc Section 4b extension) -- one CSS
// clip-path shape per role, rendered at all four tiers with a centered
// Roman numeral. Built on the Expedition View's own locked
// --sf-color-shield token (ui/starforge-ui-tokens.css) rather than a new
// hue -- every player hull stays one color family regardless of role or
// tier, since color already means "owned by the captain" in this HUD;
// shape carries the role identity, plating (see .ship-icon-hull.t3/.t4 in
// style.css) carries the tier.
//
// Wired into three screens that show a ship with no visual today
// (Shipyard's browsing list, Fleet Roster, Ship Card) -- deliberately NOT
// the Expedition View, which draws every ship on `<canvas>` via
// shipShape() and would need a different (canvas-drawn) version of this
// same shape language, not a DOM/CSS one.
const ROLE_SHAPE_CLASS: Record<string, string> = {
  Digger: "digger",
  Packmule: "packmule",
  Kestrel: "kestrel",
  Journeyman: "journeyman",
  Wildcat: "wildcat",
  Marauder: "marauder"
};

const TIER_NUMERAL: Record<NpcHullTier, string> = {
  T1: "I",
  T2: "II",
  T3: "III",
  T4: "IV"
};

const TIER_NUMBER: Record<NpcHullTier, 1 | 2 | 3 | 4> = {
  T1: 1,
  T2: 2,
  T3: 3,
  T4: 4
};

export type ShipIconSize = "sm" | "md" | "lg";

// A role not in ROLE_SHAPE_CLASS (shouldn't happen against the real fixed
// roster, but PlayerShip.role is a bare string, not a literal union)
// falls back to Journeyman's balanced hex rather than rendering nothing.
export function shipIconHtml(ship: Pick<PlayerShip, "role" | "hullTier">, size: ShipIconSize = "md"): string {
  const shapeClass = ROLE_SHAPE_CLASS[ship.role] ?? "journeyman";
  const tierNum = TIER_NUMBER[ship.hullTier];
  const roman = TIER_NUMERAL[ship.hullTier];
  return `
    <span class="ship-icon-stage size-${size}" title="${ship.role} &middot; ${ship.hullTier}">
      <span class="ship-icon-hull player ${shapeClass} t${tierNum}">
        <span class="ship-icon-numeral n${tierNum}">${roman}</span>
      </span>
    </span>
  `;
}
